/**
 * The app's screen-reader announcement channel (2026-08-19 remediation
 * Slice B, Task 3). Before this, the app had zero `aria-live` regions and
 * zero `role="status"` — classification progress and bulk-resolve outcomes
 * were completely silent to a screen-reader user.
 *
 * Visually hidden (`sr-only`), but present in the accessibility tree from
 * first render: a live region inserted into the DOM at the same moment its
 * text appears is frequently NOT announced by assistive tech, so callers
 * must mount this with `message=""` and only ever change the `message`
 * prop afterwards — never conditionally render the element itself.
 *
 * `politeness="polite"` (default) renders `role="status"` — used for routine
 * progress/outcome updates that shouldn't interrupt. `politeness="assertive"`
 * renders `role="alert"` — reserved for errors that need immediate
 * announcement.
 */
export function LiveRegion({
  message,
  politeness = 'polite',
}: {
  message: string;
  politeness?: 'polite' | 'assertive';
}) {
  return (
    <div
      role={politeness === 'assertive' ? 'alert' : 'status'}
      aria-live={politeness}
      aria-atomic="true"
      className="sr-only"
    >
      {message}
    </div>
  );
}
